

export default {
  name: 'ListingProductsListItemReviews',
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  methods: {
    goTo(link) {
      if (!link) {
        return;
      }
      this.$router.push(link);
    },
  },
  computed: {
    starStyle() {
      return {
        fullStarColor: this.$cp.gray0,
        emptyStarColor: this.$cp.white,
        starWidth: 12.96,
        starHeight: 12.96,
        radiusRatio: 1.98,
      };
    },
  },
};
